import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.addEventListener("DOMContentLoaded", () => {
    const associations = document.querySelector('.associations-slide');

    if( associations ) {
        var splide2 = new Splide( '.associations-slide', {
            type   : 'loop',
            drag   : 'free',
            focus  : 'center',
            direction: 'rtl',
            perPage: 5,
            autoWidth: true,
            gap: '6em',
            autoScroll: {
                speed: -1,
            },
            // perPage: 5,
            // perMove: 1,
            // type: 'loop',
            speed: 800,
            // interval: 4000,
            arrows: false,
            pagination: false,
            // rewind: true,
            breakpoints: {
                768: {
                    perPage: 2,
                },
                960: {
                    perPage: 2,
                },
                1100: {
                    perPage: 3,
                },
            }
        });
        splide2.mount(window.splide.Extensions);
    }
});